import React from 'react';
import { of } from 'rxjs';
import get from 'lodash.get';
import * as Actions from '../../../store/printing/print.actions';
import * as ConnectActions from '../../../store/shipstation-connect/ss-connect.actions';
import { defineMessages, FormattedMessage } from 'react-intl';
import { NOTIFICATION_DURATIONS, NOTIFICATION_TYPE_ERROR, NOTIFICATION_TYPE_INFO } from 'ui-components/services/notification-service';
import { DocumentType } from '../../../enums/document-type';

export const messages = defineMessages({
  printingPackingSlipSuccessTitle: {
    description: 'printEpics.printingPackingSlipSuccessTitle',
    defaultMessage: 'Printing Packing {docCount, plural,=0 {Slip} one {Slip} other {Slips}}...',
    id: 'v64xyG',
  },
  printingPackingSlipSuccessContent: {
    description: 'printEpics.printingPackingSlipSuccessContent',
    defaultMessage: 'Packing {docCount, plural,=0 {Slip} one {Slip} other {Slips}} sent to {printerName}.',
    id: 'XihREb',
  },
  downloadPackingSlipsStartedTitle: {
    description: 'printEpics.downloadPackingSlipsStartedTitle',
    defaultMessage: 'Downloading Packing {docCount, plural,=0 {Slip} one {Slip} other {Slips}}...',
    id: 'M2fziq',
  },
  downloadPackingSlipsStartedContent: {
    description: 'printEpics.downloadPackingSlipsStartedContent',
    defaultMessage: 'Packing {docCount, plural,=0 {Slip} one {Slip} other {Slips}} Download Started.',
    id: 's5Tgvc',
  },
  downloadPackingSlipsCompletedTitle: {
    description: 'printEpics.downloadPackingSlipsCompletedTitle',
    defaultMessage: 'Downloading Packing {docCount, plural,=0 {Slip} one {Slip} other {Slips}}...',
    id: '/97kgb',
  },
  downloadPackingSlipsCompletedContent: {
    description: 'printEpics.downloadPackingSlipsCompletedContent',
    defaultMessage: 'Packing {docCount, plural,=0 {Slip} one {Slip} other {Slips}} Download Completed.',
    id: 'dqA271',
  },
  asyncPrintPackingSlipStartedContent: {
    description: 'Notification message shown when generating a packing slip',
    defaultMessage: 'We are generating your Packing {docCount, plural,=0 {Slip} one {Slip} other {Slips}}.',
    id: 'oDmQ5S',
  },
  asyncPrintPackingSlipFailedContent: {
    description: 'Notification message shown when generating a packing slip fails',
    defaultMessage: 'Failed to generate Packing {docCount, plural,=0 {Slip} one {Slip} other {Slips}}. Please try again.',
    id: '1A2fe/',
  },
});

export const packingSlip = {
  id: DocumentType.PackingSlip.identifier,

  getDownloadStartedProps: (docCount) => ({
    title: <FormattedMessage {...messages.downloadPackingSlipsStartedTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.downloadPackingSlipsStartedContent} values={{ docCount }} />,
  }),

  getDownloadCompletedProps: (docCount) => ({
    title: <FormattedMessage {...messages.downloadPackingSlipsCompletedTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.downloadPackingSlipsCompletedContent} values={{ docCount }} />,
  }),

  getPrintedSuccessNotificationProps: (docCount, printerName) => ({
    title: <FormattedMessage {...messages.printingPackingSlipSuccessTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.printingPackingSlipSuccessContent} values={{ docCount, printerName }} />,
  }),

  getAsyncPrintStartedNotificationProps: (docCount) => ({
    title: <FormattedMessage {...messages.printingPackingSlipSuccessTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.asyncPrintPackingSlipStartedContent} values={{ docCount }} />,
    notificationType: NOTIFICATION_TYPE_INFO,
  }),

  getAsyncPrintFailedNotificationProps: (docCount) => ({
    title: <FormattedMessage {...messages.printingPackingSlipSuccessTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.asyncPrintPackingSlipFailedContent} values={{ docCount }} />,
    notificationType: NOTIFICATION_TYPE_ERROR,
    duration: NOTIFICATION_DURATIONS.MEDIUM,
  }),

  getPrintedSuccessObservable: (printJob) => {
    const printJobIds = get(printJob, 'ids');
    const printJobRequestId = get(printJob, 'requestId');
    return of(Actions.markPackingSlipPrinted(printJobIds, true), ConnectActions.printDocumentComplete(printJobRequestId));
  },
};
